<template>
  <div class="satisfaction-guarantee" id="satisfaction_guarantee">
    <div class="curveBottomLeft" :style="satisfactionBg">
      <div class="white"></div>
    </div>
    <div class="midCurve" id="midCurve" :style="satisfactionBg">
      <div :class="satisfactionClass" id="satisfaction_text">
        <!-- Generic for homepage -->
        <div
          class="grid grid-cols-1 lg:grid-cols-3 gap-10"
          v-if="!franchiseInfo"
        >
          <div class="col-span-2">
            <h2 v-html="pageData.section_2_box_1_title" />
            <div class="">
              <p v-html="pageData.section_2_box_1_text" />
            </div>
          </div>
          <img
            loading="lazy"
            v-if="
              pageData.section_2_box_1_image &&
              pageData.section_2_box_1_image.url
            "
            :src="imageLocation + pageData.section_2_box_1_image.url"
            :alt="pageData.section_2_box_1_image.alt"
            class="w-1/2 mx-auto lg:w-full"
          />
        </div>

        <!-- Specific for franchise -->
        <div
          class="grid grid-cols-1 lg:grid-cols-4 lg:gap-3 mb-6"
          v-if="franchiseInfo"
        >
          <div v-if="franchiseePhoto" class="mb-3 lg:mb-0">
            <img
              loading="lazy"
              :src="franchiseePhoto"
              alt="headshot"
              style="width: 100%; height: 100%"
            />
          </div>
          <div class="col-span-3">
            <h2>
              Proudly serving
              <span v-if="franchiseInfo.name" v-text="franchiseInfo.name" />
            </h2>
            <h3>Your Local Professional</h3>
            <p class="signature" v-html="signature" />
          </div>
        </div>
        <p
          v-if="franchiseInfo && franchiseInfo.local_information"
          v-html="franchiseInfo.local_information"
        />
        <hr class="mb-8 mt-4" />

        <!-- Shared for both -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 items-center">
          <div>
            <img
              loading="lazy"
              v-if="
                pageData.section_2_box_2_image &&
                pageData.section_2_box_2_image.url
              "
              :src="imageLocation + pageData.section_2_box_2_image.url"
              :alt="pageData.section_2_box_2_image.alt"
              class="w-1/2 mx-auto lg:w-full"
              style="height: 100%"
            />
          </div>
          <div class="col-span-2">
            <p v-html="pageData.section_2_box_2_text" />
          </div>
        </div>
      </div>
    </div>
    <div class="curveTopLeft" id="satisfaction_bottom" :style="satisfactionBg">
      <div class="white"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useNuxtApp } from "#app";

// Props
interface PageData {
  section_2_banner_image?: {
    url: string;
  };
}

interface Props {
  pageData: PageData;
  franchiseInfo: any;
  franchiseePhoto: any;
  signature: any;
}

const props = defineProps<Props>();

const { $config } = useNuxtApp();

const imageLocation = ref($config.public.sgCmsImage);
const satisfactionClass = ref("satisfaction-text");

// Computed properties
const satisfactionBg = computed(() => {
  return {
    "background-image": `url('${
      props.pageData.section_2_banner_image
        ? imageLocation.value + props.pageData.section_2_banner_image.url
        : ""
    }')`,
  };
});

// Methods
const resize = () => {
  const satisfactionText = document.getElementById("satisfaction_text");
  // const reviews = document.getElementById("reviews");
  if (satisfactionText) {
    const midCurveHeight =
      document.getElementById("midCurve")?.offsetHeight || 0;
    const satisfactionTextHeight = satisfactionText.offsetHeight;
    const diff = satisfactionTextHeight - midCurveHeight;
    const satisfactionGuarantee = document.getElementById(
      "satisfaction_guarantee"
    );

    if (satisfactionGuarantee) {
      if (diff > 0) {
        if (document.getElementById("commonIssues")) {
          satisfactionGuarantee.style.marginBottom = `${diff}px`;
        } else {
          satisfactionGuarantee.style.marginBottom = `${60 + diff}px`;
        }
      } else {
        satisfactionGuarantee.style.marginBottom = "0px";
      }
    }
  }
};

// Lifecycle hooks
onMounted(() => {
  satisfactionClass.value = "satisfaction-text ml-10 mr-10";
  resize();
  setTimeout(() => {
    resize();
  }, 500);
});

defineExpose({
  resize: () => {
    resize();
  },
});
</script>


<style scoped>
.satisfaction-guarantee {
  position: relative;
  width: 90%;
}

.satisfaction-text {
  padding: 40px;
  background: linear-gradient(180deg,#fff 40%,#eef1f4);
  border-radius: 36px;
  width: 55%;
  position: absolute;
  left: 5%;
  top: 160px;
}

.satisfaction-text h3 {
  font-size: 2em;
  line-height: 1;
  color: #00953a;
}

.satisfaction-text h3 strong {
  color: #517185;
}

.midCurve {
  border-bottom-right-radius: 33px;
  border-top-right-radius: 33px;
  background-repeat: no-repeat;
  background-size: 1440px 730px;
  background-position: left 0px top -70px;
  height: 590px;
}

.curveBottomLeft {
  width: 100%;
  height: 70px;
  background-repeat: no-repeat;
  background-size: 1440px 730px;
  background-position: left top;
}

.curveTopLeft {
  width: 100%;
  background: #fff;
  height: 70px;
  background-repeat: no-repeat;
  background-size: 1440px 730px;
  background-position: left bottom;
}

.white {
  background: #fff;
  height: 70px;
}

.curveBottomLeft .white {
  border-bottom-left-radius: 70px;
}

.curveTopLeft .white {
  border-top-left-radius: 70px;
}

.round-top-right {
  border-top-right-radius: 70px;
}

@media (max-width: 1280px) {
  .satisfaction-text {
    width: 80%;
  }
}

@media (max-width: 640px) {
  .satisfaction-guarantee {
    width: 100%;
  }

  .satisfaction-text {
    left: 0;
  }
}
</style>
